module.exports = __webpack_public_path__ + "static/img/home_1.72f0d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_1.png
// module id = E2Ly
// module chunks = 1